import React from 'react';
import { Star } from 'lucide-react';

export default function StarRating({ rating, maxRating = 5, size = 'md' }) {
  const sizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
    xl: 'w-6 h-6'
  };

  return (
    <div className="flex items-center gap-0.5" data-testid="star-rating">
      {[...Array(maxRating)].map((_, index) => (
        <Star
          key={index}
          className={`${sizeClasses[size]} ${
            index < rating
              ? 'fill-[#D4AF37] text-[#D4AF37]'
              : 'fill-transparent text-white/20'
          }`}
        />
      ))}
    </div>
  );
}
